export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/close-icon.1b29b05e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};